<template>
  <div id="footer">
    <el-row class="rowInfo">
      <!-- pc大屏显示 -->
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="12"
        class="hidden-xs-only leftCol"
      >
        <div class="infoBox">
          <div class="comName">{{ $t("footer.companyName") }}</div>
          <div class="comPhone">{{ $t("footer.mobilePhone") }}</div>
          <div class="comCall">{{ $t("footer.telephone") }}</div>
          <div class="comEmail">{{ $t("footer.email") }}</div>
          <div class="comAddress" @click="goAddress()">
            {{ $t("footer.address") }}
          </div>
          <div class="comLinkImg">
            <a
              href="http://wpa.qq.com/msgrd?v=3&uin=53509648&site=qq&menu=yes"
              target="_blank"
            >
              <img src="../../assets/img/footer/qq.png" alt="" class="wx" title="你好"/>
            </a>
            <el-popover
              placement="right"
              width="100"
              height="100"
              trigger="click"
            >
              <img
                src="../../assets/img/footer/chengliangliu.jpg"
                alt=""
                class="erweima"
                style="height: 100%; width: 100%"
              />
              <el-button slot="reference" class="elBtn">
                <img src="../../assets/img/footer/wx.png" alt="" class="qq" title="你好" />
              </el-button>
            </el-popover>
          </div>
          <div class="comReserved">
            ©2021 南京铁辰安全技术有限公司版权所有
          </div>
          <div class="ICP" @click="goIPC()">
            ICP主体备案号：苏ICP备19062206号
          </div>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="12"
        :xl="12"
        class="hidden-xs-only rightCol"
      >
        <div class="appScan">
          <div class="qrcodeBox">
            <img
              src="../../assets/img/footer/ceshi.jpg"
              alt=""
              class="erweima"
            />
            <div class="qrName">{{ $t("footer.miniPro") }}</div>
          </div>
          <div class="qrcodeBox">
            <img
              src="../../assets/img/footer/ceshi.jpg"
              alt=""
              class="erweima"
            />
            <div class="qrName">{{ $t("footer.app") }}</div>
          </div>
        </div>
      </el-col>
      <!-- 移动端手机显示 -->
      <el-col :xs="24" class="hidden-sm-and-up topCol">
        <div class="appScan">
          <div class="qrcodeBox">
            <img
              src="../../assets/img/footer/ceshi.jpg"
              alt=""
              class="erweima"
            />
            <div class="qrName">扫码关注铁辰小程序</div>
          </div>
          <div class="qrcodeBox">
            <img
              src="../../assets/img/footer/ceshi.jpg"
              alt=""
              class="erweima"
            />
            <div class="qrName">扫码下载铁辰App</div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" class="hidden-sm-and-up bottomCol">
        <div class="infoBox">
          <div class="comName">南京铁辰安全技术有限公司</div>
          <div class="comPhone">
            手机：<a href="tel:17384461558" class="phoneNum">17384461558</a
            >（冷经理）
          </div>
          <div class="comCall">
            电话：<a href="tel:025-52211001" class="phoneNum">025-52211001</a>
          </div>
          <div class="comEmail">邮箱：lengyanfei@techin-aiot.com</div>
          <div class="comAddress" @click="goAddress()">
            地址：南京市雨花台区郁金香路吉美思大厦B座303室
          </div>
          <div class="comLinkImg">
            <a
              href="http://wpa.qq.com/msgrd?v=3&uin=53509648&site=qq&menu=yes"
              target="_blank"
            >
              <img src="../../assets/img/footer/qq.png" alt="" class="wx" title="你好"/>
            </a>
            <el-popover
              placement="right"
              width="100"
              height="100"
              trigger="click"
            >
              <img
                src="../../assets/img/footer/chengliangliu.jpg"
                alt=""
                class="erweima"
                style="height: 100%; width: 100%"
              />
              <el-button slot="reference" class="elBtn">
                <img src="../../assets/img/footer/wx.png" alt="" class="qq" title="你好" />
              </el-button>
            </el-popover>
          </div>
          <div class="comReserved">
            ©2021 南京铁辰安全技术有限公司版权所有
          </div>
          <div class="ICP" @click="goIPC()">
            ICP主体备案号：苏ICP备19062206号
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    goAddress() {
      window.open(
        "http://api.map.baidu.com/geocoder?address=南京市雨花台区郁金香路吉美思大厦B座&output=html",
        "_blank"
      );
    },
    goIPC(){
      window.open(
        "https://beian.miit.gov.cn/",
        "_blank"
      );
    }
  },
  components: {},
};
</script>

<style scoped lang="scss">
#footer {
  min-height: 46rem;
  background: rgba($color: #1a2233, $alpha: 1);
  padding: 0 14%;
  .rowInfo {
    .leftCol,
    .rightCol {
      height: 46rem;
    }

    .leftCol {
      .infoBox {
        padding-top: 5%;
        div {
          margin: 2rem 0;
          color: #9da1a8;
          font-size: 1.6rem;
        }
        .comName {
          font-weight: bold;
          color: #fff;
          font-size: 2rem;
          letter-spacing: 4px;
        }

        .comReserved {
          margin-top: 4rem;
          margin-bottom: 0.5rem;
        }
        .ICP{
            color: #9da1a8;
            font-size: 12px;
            cursor: pointer;
            margin: 0;
            width: 40%;
        }

        .comLinkImg {
          .wx,
          .qq {
            width: 3rem;
            height: 3rem;
            margin-right: 3rem;
          }
          .elBtn {
            background: none;
            border: none;
            padding: 0;
            width: 3rem;
          }
        }
        .comAddress {
          cursor: pointer;
        }
      }
    }

    .rightCol {
      .appScan {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        .qrcodeBox {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .qrName {
            font-size: 1.2rem;
            color: #fff;
            margin-top: 1rem;
            letter-spacing: 2px;
          }
        }
        .erweima {
          width: 16rem;
          height: 16rem;
        }
      }
    }

    .topCol {
      .appScan {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 2rem;
        .qrcodeBox {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          .qrName {
            font-size: 1.2rem;
            color: #fff;
            margin-top: 1rem;
            letter-spacing: 2px;
          }
        }
        .erweima {
          width: 12rem;
          height: 12rem;
        }
      }
    }
    .bottomCol {
      .infoBox {
        div {
          margin: 2rem 0;
          color: #9da1a8;
          font-size: 1.4rem;
        }
        .comName {
          font-weight: bold;
          color: #fff;
          font-size: 1.6rem;
          letter-spacing: 2px;
        }

        .comReserved {
          margin-top: 5rem;
          margin-bottom: 0.5rem;
        }
        .ICP{
            color: #9da1a8;
            font-size: 12px;
            cursor: pointer;
            margin: 0;
            width: 90%;
        }

        .comLinkImg {
          .wx,
          .qq {
            width: 3rem;
            height: 3rem;
            margin-right: 3rem;
          }
          .elBtn {
            background: none;
            border: none;
            padding: 0;
            width: 3rem;
          }
        }
        .phoneNum {
          color: #9da1a8;
          text-decoration: none;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          -moz-tap-highlight-color: rgba(0, 0, 0, 0);
          -ms-tap-highlight-color: rgba(0, 0, 0, 0);
          -o-tap-highlight-color: rgba(0, 0, 0, 0);
          tap-highlight-color: rgba(0, 0, 0, 0);
        }
      }
    }
  }
}
@import '../../assets/responsive/footer.scss'
</style>

